import type { Component } from "@/pages/management/technicalsheets/technicalsheet/services/dto/TechnicalSheet.ts";
import type { ComponentCostPrice } from "@/pages/management/technicalsheets/technicalsheet/services/dto/FinancialData.ts";
import { CostPriceType } from "@/pages/management/technicalsheets/technicalsheet/components/CostPriceType.ts";

export const calculateTotalCostPriceForOneUnit = (
  components: Component[],
  producedQuantity: number,
  componentsCostPrices: ComponentCostPrice[] | undefined,
  costType: CostPriceType = CostPriceType.CURRENT,
): number => {
  if (producedQuantity === 0) return 0;

  return components.reduce((total: number, component: Component) => {
    const costData = componentsCostPrices?.find(
      (price) => price.id === component.componentId,
    );
    const costPrice =
      costType === CostPriceType.CURRENT ?
        costData?.costPrice
      : costData?.previousCostPrice;
    if (costPrice != undefined) {
      return (
        total +
        (component.grossQuantity * costPrice * component.coefficient) /
          producedQuantity
      );
    }
    return total;
  }, 0);
};

export const calculatePriceWithoutTax = (
  priceInclTax?: number,
  vatRate?: number,
): number => {
  if (priceInclTax == undefined || vatRate == undefined) return 0;
  return priceInclTax / (1 + vatRate / 100);
};

export const calculateMarginPercentage = (
  priceWithoutTax: number,
  totalCostPrice: number,
): number => {
  if (priceWithoutTax === 0) return 0;
  return ((priceWithoutTax - totalCostPrice) * 100) / priceWithoutTax;
};

export const calculateMargin = (
  priceWithoutTax: number,
  totalCostPrice: number,
): number => {
  if (priceWithoutTax === 0) return 0;
  return priceWithoutTax - totalCostPrice;
};

export const calculateCoeff = (
  priceWithoutTax: number,
  totalCostPrice: number,
): number => {
  if (priceWithoutTax === 0 || totalCostPrice === 0) return 0;
  return priceWithoutTax / totalCostPrice;
};

export const calculateRatio = (
  priceWithoutTax: number,
  totalCostPrice: number,
): number => {
  if (priceWithoutTax === 0) return 0;
  return (totalCostPrice * 100) / priceWithoutTax;
};

export const calculateVariationAmount = (
  currentAmount: number,
  previousAmount: number,
): number => {
  return currentAmount - previousAmount;
};

export const calculateVariationPercentage = (
  currentAmount: number,
  previousAmount: number,
): number => {
  if (previousAmount === 0) return 0;
  return ((currentAmount - previousAmount) / previousAmount) * 100;
};
